import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppInitState } from '../state/app-init.state';

export const selectAppInitState = createFeatureSelector<AppInitState>('appInit');

export const selectAppInitStatus = createSelector(selectAppInitState, (state) => state.state);
